import { useState } from 'react'
import { X, CheckCircle } from 'lucide-react'
import { useSubmitFeedback } from '../hooks/useFeedback'
import './Modal.css'

export default function FeedbackModal({ context, onClose }) {
  const [feedbackType, setFeedbackType] = useState('bug')
  const [message, setMessage] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const { mutate: submit, isPending } = useSubmitFeedback()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!message.trim()) return

    submit(
      { feedback_type: feedbackType, message: message.trim(), context },
      { onSuccess: () => setSubmitted(true) }
    )
  }

  if (submitted) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content confirm-modal" onClick={(e) => e.stopPropagation()}>
          <div className="confirm-content">
            <CheckCircle size={40} style={{ color: 'var(--accent-primary)', marginBottom: '0.5rem' }} />
            <p style={{ fontWeight: 700, fontSize: '1.125rem', marginBottom: '0.25rem' }}>Thanks for your feedback!</p>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              We'll review it and use it to improve the app.
            </p>
          </div>
          <div className="modal-actions">
            <button className="btn-primary btn-action" onClick={onClose}>Done</button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Send Feedback</h2>
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', margin: '0 1.25rem', lineHeight: 1.4 }}>
          Want a faster conversation? <a href="https://discord.gg/DpRjqBNE4D" onClick={(e) => { e.preventDefault(); import('../utils/openExternalUrl').then(m => m.openExternalUrl('https://discord.gg/DpRjqBNE4D')) }} style={{ color: 'var(--accent-primary)', textDecoration: 'none', fontWeight: 600, cursor: 'pointer' }}>Join our Discord</a> for live discussion and updates.
        </p>
        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Type</label>
            <select value={feedbackType} onChange={(e) => setFeedbackType(e.target.value)}>
              <option value="bug">Bug Report</option>
              <option value="feature">Feature Request</option>
              <option value="general">General Feedback</option>
            </select>
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Describe the issue or suggestion..."
              rows={5}
              required
            />
          </div>
        </form>
        <div className="modal-actions">
          <button className="btn-secondary btn-action" onClick={onClose}>Cancel</button>
          <button
            className="btn-primary btn-action"
            onClick={handleSubmit}
            disabled={isPending || !message.trim()}
          >
            {isPending ? 'Sending...' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  )
}
